import React, { useState } from "react";
import {
  View,
  Text,
  Image,
  Dimensions,
  Animated,
  TouchableOpacity,
  StyleSheet,
  ScrollView,
  FlatList,
  TextInput,
} from "react-native";
import Header from "../../component/header";
import Background from "../../component/background";
import NewsInfo from "../../component/newsInfo";
import TabbarOption from "../../component/tabbarOption";
import { FontAwesome } from "@expo/vector-icons";
const { width, height } = Dimensions.get("window");
export default function index({ navigation, User, route }) {
  const [data, setData] = useState([
    "100 meter",
    "200 meter",
    "4x400 meter",
    "Triple Jump",
    "Pole Vault",
    "400 meter",
    "800 meter",
    "4x100 meter",
    "High Jump",
    "Decathon",
    "1500 meter",
    "5000 meter",
    "Shot Put",
    "Long Jump",
    "Discus Throw",
    "100m Hurdles",
    "400m Hurdles",
    "Jevelin Throw",
    "Mixed Relay",
    "3000m Steplechase",
  ]);
  return (
    <View style={styles.container}>
      <Header
        onPressHome={() => {
          navigation.navigate("HomeUser");
        }}
        onPressCompetition={() => {
          navigation.navigate("CompetitionUser");
        }}
        onPressAthlete={() => {
          navigation.navigate("AthleteUser");
        }}
        onPressLogout={() => {
          navigation.navigate("Login");
        }}
        backgroundColorHome="#FFFFFF"
        User
        navigation={navigation}
      />
      <ScrollView>
        <View>
          <Background navigation={navigation} Title={route.params.name} />
          <NewsInfo
            route={route}
            navigation={navigation}
            showDetail
            User
            condition
          />
        </View>
      </ScrollView>
    </View>
  );
}
const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#CCE4FF",
    flexDirection: "row",
  },
  imgTitle: {
    width: 777,
    height: 451,
    alignSelf: "center",
    marginVertical: 40,
  },
  viewDetail: {
    marginVertical: 20,
    marginHorizontal: width * 0.1,
  },
  textSubject: {
    fontSize: 28,
    fontFamily: "Prompt",
    color: "#2B6AB1",
  },
  viewEvent: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  textGenderEvent: {
    fontSize: 22,
    fontFamily: "Prompt",
    color: "#2B6AB1",
  },
  textItemEvent: {
    fontSize: 16,
    fontFamily: "Prompt",
    color: "#2B6AB1",
  },
  textDate: {
    fontSize: 20,
    fontFamily: "Prompt",
    color: "#2B6AB1",
  },
  buttonRegister: {
    width: 201,
    height: 56,
    borderRadius: 28,
    justifyContent: "center",
    marginTop: 25,
  },
  textRegister: {
    fontSize: 25,
    fontFamily: "Prompt",
    color: "#FFFFFF",
    alignSelf: "center",
  },
});
